exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-footer {\n  font-weight: bold;\n}\n.app-footer__copyright {\n  padding: 60px 16px;\n  font-size: 11px;\n  color: gray;\n  text-align: center;\n}\n", ""]);

// exports
